
<template>
  <div class="robot">
    <div class="main-top">
      <img src="../assets/img/main-title.jpg" alt="" />
    </div>
    <div class="main-content">
      <div class="main-title">
        <h1>系统简介</h1>
      </div>
      <div class="main-summary">
        <div class="summary-img">
          <img src="../assets/img/robot-title.jpg" alt="" />
        </div>
        <div class="summary-text">
          <b> 轨道式自动巡检机器人系统 </b>
          <ul>
            <li>可搭载视频设备和多种传感器，沿轨道对基站设备进行<b>自动巡检</b>，能够实现基站设备全方位、全自主智能巡检和监控</li>
            <li>可以<b>人工控制巡检</b>，获取需要巡检设备的重要信息。本自动巡检系统大大提高了检测的范围，提高了巡检的效率和智能化水平</li>
            <li>可有效<b>降低设备维护成本</b>，提高设备巡检、设备管理的自动化和智能化水平，为通信基站和无人值守站提供新型的技术巡检手段和更可靠的安全保障</li>
          </ul>
        </div>
      </div>
      <div class="main-title">
        <h1>人工巡检VS自动巡检</h1>
      </div>
      <div class="robot-vs-manual-img">
        <img src="../assets/img/robotvsmanual.png" alt="">
      </div>
      <div class="robot-vs-result-img">
        <img src="../assets/img/robot-result.png" alt="">
      </div>
      <div class="main-title">
        <h1>功能介绍</h1>
      </div>
      <div class="robot-function-img">
        <img src="../assets/img/robot-function.png" alt="">
      </div>
      <div class="main-title">
        <h1>系统组成</h1>
      </div>
      <div class="robot-zucheng-img">
        <img src="../assets/img/robot-zucheng.png" alt="">
      </div>
      <div class="main-title">
        <h1>应用集成</h1>
      </div>
      <div class="robot-jicheng-img">
        <img src="../assets/img/robot-jicheng.png" alt="">
      </div>      
      <div class="gotoalarm" @click="goto">进入体验></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HelloWorld",
  data() {
    return {
      map: {},
    };
  },
  mounted() {},
  methods: {
    goto() {
      window.open("http://39.104.79.20/");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.robot {
  background-color: #f7f7f7;
  .main-top {
    margin: 1vh 0 0 0;
    height: 13vh;
    img {
      height: 100%;
      width: 100%;
    }
  }
  .main-content {
    margin: 0 5vw;
    .main-title {
      border-bottom: 1px solid #ecedf1;
      overflow: hidden;
      height: 100px;
      h1 {
        background: url(../assets/img/red-line.png) no-repeat center bottom;
        font-weight: 700;
        width: 160px;
        line-height: 100px;
        margin: 0;
      }
    }
    .main-summary {
      display: flex;
      align-items: center;
      .summary-img {
        padding: 5vh 0;
        width: 30vw;
        img {
          width: 100%;
          height: auto;
        }
      }
      .summary-text {
        padding: 0 0 0 2vw;
        flex: 1;
        b,li {
          text-indent: 28px;
          line-height: 40px;
          font-size: 22px;
        }
      }
    }
    .robot-vs-manual-img {
      width: 75vw;
      height: 35vw;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .robot-vs-result-img {
      width: 75vw;
      height: 4vw;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .robot-function-img {
      width: 65vw;
      height: 45vw;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .robot-zucheng-img {
      width: 75vw;
      height: 40vw;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .robot-jicheng-img {
      width: 75vw;
      height: 40vw;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .alarm-summary {
      display: flex;
      padding: 5vh 0;
      .summary-tip {
        font-size: 20px;
        line-height: 35px;
      }
    }
    .gotoalarm {
      text-align: center;
      font-size: 30px;
      color: #dd4242;
      text-decoration: underline;
      line-height: 70px;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/robot.vue